import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { TravelNerdBanner } from 'src/features/travel/TravelNerdBanner';
import { useReviewContext } from '../../Context';
import ReviewSignUp from '../SignUp';
import { REVIEW_TRAVEL_NERD_SLUGS } from './constants';
export default function ReviewBanner() {
  const $ = _c(3);
  const {
    slug
  } = useReviewContext();
  const shouldShowTravelNerdBanner = REVIEW_TRAVEL_NERD_SLUGS.includes(slug);
  if (shouldShowTravelNerdBanner) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        mx: {
          xs: -2,
          sm: 0
        }
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Box sx={t0}><TravelNerdBanner noImage={true} analytics={{
          impressionPosition: 3
        }} /></Box>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t0;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ReviewSignUp />;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}